import { render } from "./WorldAxis.vue?vue&type=template&id=4e655c92&scoped=true&ts=true"
import script from "./WorldAxis.vue?vue&type=script&lang=ts"
export * from "./WorldAxis.vue?vue&type=script&lang=ts"

import "./WorldAxis.vue?vue&type=style&index=0&id=4e655c92&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src678506843/src/babyhead-viewer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e655c92"]])

export default __exports__